import EmailTemplateList from './emailTemplateList';

export default EmailTemplateList;
